import { z } from "zod";
import { nonNegativeMoneySchema, uuidSchema } from "../common/primitives.js";
import { writeOffLossKeySchema } from "./enums.js";
/**
 * Market ayarları (Prompt 16). Satır ŞİRKET düzeyindedir; `stationId` doluysa o istasyonun geçersiz kılmasıdır
 * (`pos_settings` kalıbı). Hiçbir eşik koda gömülmez (AGENTS.md §3.12) ve tümü "doğrulanmalı" gelir.
 */
const percentSchema = z
    .string()
    .regex(/^\d{1,3}(\.\d{1,2})?$/, "Yüzde en fazla 2 ondalıklı sayı olmalıdır")
    .describe('Yüzde (dizge). Örn. "0.5" = %0,5');
const marginSchema = z
    .string()
    .regex(/^\d{1,2}(\.\d{1,2})?$/, "Marj 0 ile 99,99 arasında olmalıdır")
    .describe('Yüzde (dizge). Örn. "25" = %25');
export const writeOffLossKeysSchema = z
    .object({
    EXPIRED: writeOffLossKeySchema,
    DAMAGED: writeOffLossKeySchema,
    THEFT: writeOffLossKeySchema,
    INTERNAL_USE: writeOffLossKeySchema,
    OTHER: writeOffLossKeySchema,
})
    .describe("Fire nedeni → kayıp anahtarı (NORMAL_LOSS = normal fire, ABNORMAL_LOSS = olağandışı kayıp)");
const settingsFields = {
    matchQuantityTolerancePercent: percentSchema.describe("Üçlü eşleştirme: miktar farkı toleransı (%)"),
    matchPriceTolerancePercent: percentSchema.describe("Üçlü eşleştirme: birim fiyat farkı toleransı (%)"),
    matchAmountTolerance: nonNegativeMoneySchema.describe("Üçlü eşleştirme: satır tutar farkı mutlak toleransı (kuruş)"),
    expiryWarningDays: z.number().int().min(0).max(365).describe("SKT'ye bu kadar gün kala uyarı"),
    deadStockDays: z.number().int().min(1).max(3650).describe("Bu kadar gündür satılmayan ürün ölü stoktur"),
    salesVelocityDays: z.number().int().min(1).max(365).describe("Satış hızı penceresi (gün)"),
    defaultTargetMarginPercent: marginSchema.describe("Kategoride hedef marj yoksa kullanılan brüt marj (%)"),
    priceRoundTo: z
        .string()
        .regex(/^\d{1,6}(\.\d{1,2})?$/, "Yuvarlama adımı en fazla 2 ondalıklı pozitif sayı olmalıdır")
        .refine((value) => Number(value) > 0, "Yuvarlama adımı sıfırdan büyük olmalıdır")
        .describe('Satış fiyatı önerisi bu adıma yukarı yuvarlanır (₺). Örn. "0.25"'),
    allowNegativeStock: z
        .boolean()
        .describe("Negatif stoğa izin: false → transfer ve fire stok yetersizse reddedilir (kasa satışı ASLA reddedilmez)"),
    writeOffLossKeys: writeOffLossKeysSchema,
    writeOffVatReversal: z
        .boolean()
        .describe("Firede indirilen KDV düzeltmesi (mevzuat sorusu #60) — v1'de yalnızca bilgi, fiş üretmez"),
    countApprovalThreshold: nonNegativeMoneySchema.describe("Sayım net farkı bu tutarı (kuruş, mutlak) aşarsa onay motoru (`STOCK_COUNT`) devreye girer"),
    cycleCountStaleDays: z
        .number()
        .int()
        .min(1)
        .max(365)
        .describe("Döngüsel sayım: bu kadar gündür sayılmayan ürün önerilir"),
    licenseWarningDays: z
        .number()
        .int()
        .min(0)
        .max(365)
        .describe("Satış belgesinin bitişine bu kadar gün kala uyarı"),
};
export const marketSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().describe("Dolu ise bu istasyona özel geçersiz kılma"),
    /** true → kayıt YOKTUR; dönen değerler ürün varsayılanıdır (ilk PUT satırı oluşturur). */
    isDefault: z.boolean(),
    ...settingsFields,
    needsVerification: z.boolean().describe("Değerler işletme tarafından doğrulanmalı"),
    version: z.number().int().min(0).describe("İyimser kilit sürümü; 0 = henüz kaydedilmemiş"),
});
/** PUT ile TAMAMI değiştirilir (kısmi güncelleme yok). */
export const saveMarketSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().optional().describe("Verilirse istasyon geçersiz kılması yazılır"),
    ...settingsFields,
    needsVerification: z.boolean().optional(),
    version: z.number().int().min(0).describe("Okunan sürüm; 0 = kayıt yoktu"),
});
export const marketSettingsQuerySchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.optional().describe("Verilirse istasyonun ETKİN ayarı (yoksa şirket satırı) döner"),
});
//# sourceMappingURL=settings.js.map